/**
 * Replace the tokens in a string of text
 * @param {string} text   The text to replace tokens in.
 * @param {object} tokens An object with keys of the tokens to replace
 *                        and values of the replacements.
 */
function replaceTokens(text, tokens) {
  if (!text) {
    return "";
  }

  const tokenRegEx = /([%@!]\w+|\[[\w:]+\])/g;
  const textParts = text.split(tokenRegEx);

  const replacedTextParts = textParts.map(value =>
    value in tokens ? tokens[value] : value
  );

  return replacedTextParts.join("");
}

export default function replaceImages(
  text,
  images,
  margin = "0px",
  width = "100%",
  display = "inline",
  borderRadius = "0px"
) {
  const imageTokens = {};

  images.forEach((image, i) => {
    imageTokens[`[image${i}:token]`] =
      `<img style="width: ${width}; margin: ${margin}; display: ${display};" src="${image.url}" alt="${image.altTag}" lazy="true" />`;
  });

  if (images.length >= 2) {
    imageTokens["[image_responsive:token]"] = `
    <picture style="display: block;">
      <source media="(max-width: 990px)" srcset="${images[0].url}" />
      <source media="(min-width: 991px)" srcset="${images[1].url}" />
      <img src="${images[0].url}" alt="${images[0].altTag}" style="display: block; margin: 0 auto; max-width: 100%; border-radius: ${borderRadius};" />
    </picture>`;
  }

  const replacedText = replaceTokens(text, imageTokens);

  return replacedText;
}
